import { generateUtilityClasses } from '@mui/material';

// generateUtilityClasses가 이미 타입을 제공하므로 별도 인터페이스 불필요
export const radioGroupClasses = generateUtilityClasses('RadioGroup', [
  'root',
  'option',
  'customOption',
  'hiddenInput',
]);

// ✅ themes 객체 완전 제거 - styleOverrides와 defaultProps가 컴포넌트 내부로 이전됨
// ✅ module augmentation 완전 제거 - MUI theme 시스템 의존성 제거
